module.exports = __webpack_public_path__ + "img/St-Anthony.c82fc332.jpg";